<template>
  <form @submit.prevent="addMagazine">
    <modal-card title="Add Magazine" contains-dropdown>
      <b-field label="Add Magazine">
        <b-select v-model="form.type" expanded>
          <option value="all" selected>All</option>
          <option value="magazine">Magazine</option>
        </b-select>
      </b-field>

      <b-field label="Magazine" v-if="form.type=='magazine'">
        <magazine-select
          @change="magazine => setMagazine(magazine)"
        ></magazine-select>
      </b-field>
      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>
        <button class="button is-primary">
          Add Magazine
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
export default {
  props: {
    vendor: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      activeTab: 0,
      isImageModalActive: false,
      publication: 1,
      form: new window.Form({
        type: 'magazine',
        'magazine': null
      })
    }
  },
  methods: {
    addMagazine: function () {
      this.form.post(`/admin/api/wifi/vendors/${window.app.$route.params.id}/magazines`).then(() => {
        this.whenAdded();
      });
    },
    setMagazine(magazine) {
      this.form.magazine = magazine.id;
    },
    whenAdded() {
      this.$emit('reload', 'magazine')
      this.$parent.close()
    },
  }
}
</script>
